
const interactionOutcomeUtils = {
    /**
     * Utils method that can be used to check if an answer is a part of the correctResponses array or if the
     * isCorrect outcome provided for textEntryInteraction variants equals 'true'
     * @param answerOption Can be identifier for a simpleChoice or a pair from matching or drag and drop
     * @param correctResponses Array sent into the interaction if provided
     * @param outcomeIsCorrect String value provided as 'true' if correct for textEntryInteraction variants.
     * @returns {boolean}
     */
    isAnswerCorrect(answerOption, correctResponses, outcomeIsCorrect) {
        if (outcomeIsCorrect === 'true') {
            return true;
        }
        if (!Array.isArray(correctResponses)) {
            return false;
        }
        return correctResponses.indexOf(answerOption) > -1;
    },
    isAnswerPartiallyCorrect(outcomeIsPartiallyCorrect) {
        return outcomeIsPartiallyCorrect === 'true';
    },
};

export default interactionOutcomeUtils;
